import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useI18n } from 'vue-i18n'
import DashboardDataSection from '../components/DashboardDataSection.vue'
import { useFeature } from '@/pinia/features'


export default /*@__PURE__*/_defineComponent({
  __name: 'BuildingScoreGraphSection',
  setup(__props) {

const { locale } = useI18n()
const { feature: currentSection } = useFeature('home/analytics/portfolio/buildingscore/graphs')

return (_ctx: any,_cache: any) => {
  return (_unref(currentSection) && _unref(currentSection).component)
    ? (_openBlock(), _createBlock(DashboardDataSection, _mergeProps({
        key: 0,
        isMissingFilter: false,
        sections: _unref(currentSection).children?.map((f) => ({ ...f, type: f.name })),
        title: _unref(currentSection).title[_unref(locale)],
        info: _unref(currentSection).info?.[_unref(locale)]
      }, _unref(currentSection).props), null, 16, ["sections", "title", "info"]))
    : _createCommentVNode("", true)
}
}

})